export class AlreadyLockedException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'AlreadyLockedException';
    Object.setPrototypeOf(this, AlreadyLockedException.prototype);
  }
}

export class OutOfDateException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'OutOfDateException';
    Object.setPrototypeOf(this, OutOfDateException.prototype);
  }
}
